import React from 'react';
import { useIntl } from 'react-intl';
import { MdLockOutline } from 'react-icons/md';
import { PromoBanner, PROMO_BANNER_DENSITY_COMPACT } from '@aibuild/ui';

/** A run on the person's computer uploads its results, which they should know before it does. */
const LocalRunStorageNotice: React.FC = () => {
  const intl = useIntl();
  return (
    <PromoBanner
      density={PROMO_BANNER_DENSITY_COMPACT}
      icon={<MdLockOutline />}
      title={intl.formatMessage({
        id: 'apps.run.localRun.storageNotice',
        defaultMessage:
          "Your results are stored securely. Files this app creates on your computer are saved to your organisation's private Aibuild storage, encrypted in transit and at rest, so you can open and download them here.",
      })}
      dataTestId="app-run__storage-notice"
    />
  );
};

export default LocalRunStorageNotice;
